

import {  Body, Injectable } from "@nestjs/common";

import {  HttpService } from "@nestjs/axios";

import { switchMap } from "rxjs";
import { AddressEntity } from "../../models/address.entity";
import { CityEntity } from "../../models/city.entity";
import { GpsCoordinatesEntity } from "../../models/gpscoordinates.entity";
import { StreetEntity } from "../../models/street.entity";
import { DatabaseService } from "../database/database.service";
import { QueryBuilder } from "typeorm";



@Injectable()
export class LocationService  {

  constructor(private databaseService:DatabaseService) {}

   
  async getCities()
  {
    
    let queryBuilder=this.databaseService.cityRepository
    .createQueryBuilder('city')

    let data =await queryBuilder.getMany()
    return data;
  }


  async getStreets(cityId:number)
  {
   
    let queryBuilder=this.databaseService.streetRepo
    .createQueryBuilder('streets')
    .leftJoinAndSelect('streets.city','city')
    .where("streets.city= :city", { city: cityId })
    

    let data =await queryBuilder.getMany()
  
    return data;
  }



  async getStreetByName(streetName:string)
  {
   
    let queryBuilder=this.databaseService.streetRepo
    .createQueryBuilder('streets')
    .where({name:streetName})
    

    let data =await queryBuilder.getOne()
  
    return data;
  }


  async newAddress(params)
  {
    
    let street = await this.databaseService.streetRepo.findOne(params.streetId)
    let city = await this.databaseService.cityRepository.findOne(params.cityId)
    street.city=city
    let address=new AddressEntity()
    address.street=street
    address.apartment=params.apartment
    address.houseNum=params.houseNum
    address.zipcode=params.zipcode

    

    
     
   

    if(params.gpsLatitude && params.gpsLongitude)
    {
      let gpsCoords = new GpsCoordinatesEntity()
      if(params.gpsLatitude)
      gpsCoords.gpsLatitude=parseFloat(params.gpsLatitude)
      if(params.gpsLongitude)
      gpsCoords.gpsLongitude=parseFloat(params.gpsLongitude)
      gpsCoords= await this.databaseService.gpsCoordRepo.save(gpsCoords)
    }
    
    
    
    let gpsCoords = new GpsCoordinatesEntity()
    if(params.gpsLatitude)
    gpsCoords.gpsLatitude=parseFloat(params.gpsLatitude)
    if(params.gpsLongitude)
    gpsCoords.gpsLongitude=parseFloat(params.gpsLongitude)
    
    gpsCoords= await this.databaseService.gpsCoordRepo.save(gpsCoords)
    
    address.gpsCoord=gpsCoords
    let s=this.databaseService.serviceRepo.findOne(params.streetId)
    
    let alreadExists= await this.databaseService.locationRepo.createQueryBuilder('location')
    .leftJoinAndSelect('location.street','street')
    .leftJoinAndSelect('street.city','city')
    .leftJoinAndSelect('location.gpsCoord','gps')
    
    .where({
    houseNum: address.houseNum,
    apartment: address.apartment,
    zipcode: address.zipcode,
    street:s,
    
   
  }).getOne()
 
  
    if(alreadExists)return alreadExists
  
    
    address= await this.databaseService.locationRepo.save(address)
   
 
    return address;
  }
 
 

  


  
  async newStreet(params){
    let city=new CityEntity()
    city.cityId=params.cityId
    let queryBuilder=this.databaseService.streetRepo
    .createQueryBuilder('street').insert().into(StreetEntity)
    .values({
      name:params.name,
      city:city
    })
    
    let errorMsg
    let data= await queryBuilder.execute().catch((error)=>{
      errorMsg=error.sqlMessage
    }).then(async(result:any)=>{
          if(errorMsg)
          {
            return {error:errorMsg}
          }
          else
          {
            let queryBuilder2 =this.databaseService.streetRepo
            .createQueryBuilder('street')
            .leftJoinAndSelect('street.city','city')
            .where({streetId:result.identifiers[0].streetId})
  
            let newStreet = await queryBuilder2.getOne()
            return {
                  streetId:newStreet.streetId,
                  name:newStreet.name,
                  cityId:newStreet.city.cityId

                }
          }
    })

    return data


  }
  
  /*
  async deleteCity(id:number) {
    
    let queryBuilder = this.databaseService.cityRepository
    .createQueryBuilder('city')
    .delete()
    .from(CityEntity)
    .where({cityId:id})
    let error=false
    let ret = await queryBuilder.execute().catch(()=>{
        error=true

    }).then((res:any)=>{
      if(error)return 2   //city is referenced by other address
      else if(res.affected==1)return 0 //successful delete
      else return 1  //no such city
    })

    return ret
    
  }

  async deleteStreet(id:number) {
    
    let queryBuilder = this.databaseService.streetRepo
    .createQueryBuilder('street')
    .delete()
    .from(StreetEntity)
    .where({streetId:id})
    let error=false
    let ret = await queryBuilder.execute().catch(()=>{
        error=true

    }).then((res:any)=>{
      if(error)return 2   //street is referenced by other address
      else if(res.affected==1)return 0 //successful delete
      else return 1  //no such street
    })

    return ret
    
  }

  async deleteAddress(id)
  {
    let queryBuilder = this.databaseService.locationRepo
    .createQueryBuilder('address')
    .delete()
    .from(AddressEntity)
    .where({addressId:id})

    let result = await queryBuilder.execute()
    .catch(()=>{return false})
    .then((result:any)=>{
      if(result.affected==1)return {success:true}
      return {success:true}
    })
   
    return result
  }



 


  async newCity(params)
  {
    
   

    let queryBuilder=this.databaseService.cityRepository
    .createQueryBuilder('city').insert().into(CityEntity)
    .values({
      name:params.name,
      zipcode:params.zipcode
    })

    let errorMsg
    let data2= await queryBuilder.execute().catch((error)=>{
      errorMsg=error.sqlMessage
    }).then(async(result:any)=>{
          if(errorMsg)
          {
            return {error:errorMsg}
          }
          else
          {
            let queryBuilder2 =this.databaseService.cityRepository
            .createQueryBuilder('city')
            .where({cityId:result.identifiers[0].cityId})
  
            let newCity = await queryBuilder2.getOne()
            return newCity
          }
    })

   return data2
  }*/





  


    
    
     


 


  

 


  

 
}
